/* eslint-disable no-restricted-syntax */
import { getToken } from "../utils/authUtils";
import { parseJSON } from "./parseJSON";

const urlBase = `${process.env.API_URL}/ticketing/legales/`;
const readUrl = (url = "") => `${urlBase}${url}`;

export const getCategories = async () => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`categories`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  if (res.data) {
    // se adapta el response para usar el hook useFetcher
    return { result: res.data };
  }

  return res;
};
